import YoutubePopup from "@/components/other/YoutubePopup";
import {getUrlFromatted} from "@/components/tour/sections/TourMediaSection";
import {getColor} from "@/styles/ThemeConfig";
import {breakpoints} from "@/styles/sizes";
import styled from "styled-components";


export default function VariantBVideoSection({videoThumbnail, videoTitle,videoSubtitle,videoUrl})
{
    return <div
    >
        {
            (videoThumbnail && videoUrl) && <div>
                <YoutubePopup
                    title={`${videoTitle} ${videoSubtitle}`}
                    thumbnail={videoThumbnail}
                    url={getUrlFromatted(videoUrl)}
                />
            </div>
        }
    </div>
}
